import PlayerInterface from 'interfaces/players-data-interfaces/player-interface';
import {replaceLineupPlayer, sortPlayersByLineupPositionId} from 'helpers/lineup-helper';
import Action from 'components/organisms/late-swap/actions';
import {createChecksumForLineupPlayers} from 'helpers/hash';
import Const from 'const';

const PlayersToExchange = {
    setPlayersSwapped(searchPlayer: PlayerInterface, replacePlayer: PlayerInterface, lineupId: string) {
        return (dispatch, getState) => {
            const {
                lineupsData: {lineups},
                sportConfig,
            } = getState();
            const lineup = lineups.getLineup(lineupId);

            let players = replaceLineupPlayer(searchPlayer, replacePlayer, lineup.players);

            if (sportConfig.isGameTypeClassic() && !sportConfig.isSportF1()) {
                const positionsOrder = sportConfig.getConfigProp('positionsOrder', {});
                players = sortPlayersByLineupPositionId(players, positionsOrder);
            }

            const lineupTotals = dispatch(Action.calcLineupTotals(players));

            const updatedLineup = {
                ...lineup,
                players,
                playersChecksum: createChecksumForLineupPlayers(players),
                ...lineupTotals,
            };

            dispatch(this.setSwappedPlayersLineupId(lineupId));
            dispatch(Action.setOptimizedLineupViews([updatedLineup]));
            dispatch(Action.setLineupsUsedPlayers());
            dispatch(Action.createLineupPlayerMap());
            dispatch(Action.removePlayerFromLineupsFilterByCheckedPlayer(searchPlayer.getId()));
        };
    },

    setSwappedPlayersLineupId(lineupId) {
        return {
            type: Const.SWAPPED_PLAYERS_SET_LAST_UPDATED_LINEUP_ID,
            value: lineupId,
        };
    },
};

export default {...Action, ...PlayersToExchange};
